module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_chiefetz_sm-1899d8adb8c827ceb311e0ee61e9512e.png";